import {
  Cities
} from 'helpers/models';

const mapCityDetails = (obj, included) => {
  const item = obj;

  return item.data.flatMap((rel) => {
    return included.flatMap((meta) => {

      if (rel.id === meta.id) {

        return {
          name: meta.attributes?.field_name?.processed,
          code: meta.attributes?.field_code?.processed,
          latitude: meta.attributes?.field_latitude,
          longitude: meta.attributes?.field_longitude
        };
      }

      return [];
    });
  });
};

export const mapCities = (result) => {

  return result.data
    .map((item) => {
      return {
        attributes: {
          cities: mapCityDetails(item.relationships.field_cities, result.included)
        }
      };
    })
    .map((content) => {
      return new Cities(content).mapToStandard();
    });
};